export const FREELANCE = 'freelance';
export const SABBATICAL = 'sabbatical';
export const SEEKING_WORK = 'seeking-work';
export const CIVILIAN_MILITARY_SERVICE = 'civilian-military-service';
export const MATERNITY_LEAVE = 'maternity-leave';
export const PENSION = 'pension';
export const SUMMER_INTERNSHIP = 'summer-internship';
export const SEASONAL_WORK = 'seasonal-work';
export const HONORARY_POST = 'honorary-post';

export function isTitleEligible (careerType)
{
	return ![SEEKING_WORK, PENSION]
		.includes(careerType.naturalId);
}

export function isTitleMandatory (careerType)
{
	return isTitleEligible(careerType)
		&& ![CIVILIAN_MILITARY_SERVICE, MATERNITY_LEAVE, PENSION].includes(careerType.naturalId);
}

export function isCompanyNameMandatory (careerType)
{
	return ![HONORARY_POST, SEASONAL_WORK].includes(careerType.naturalId)
}

export function isDescriptionMandatory (careerType)
{
	return ![SABBATICAL, SEEKING_WORK, CIVILIAN_MILITARY_SERVICE, MATERNITY_LEAVE, PENSION]
		.includes(careerType.naturalId);
}

export function isIndustrialSectorsMandatory (careerType)
{
	return isTagsEligible(careerType);
}

export function isOrganisationAreaMandatory (careerType)
{
	return isTagsEligible(careerType);
}

export function isCareerLevelMandatory (careerType)
{
	return isTagsEligible(careerType);
}

export function isFunctionsMandatory (careerType)
{
	return isTagsEligible(careerType);
}

function isTagsEligible (careerType)
{
	return ![SUMMER_INTERNSHIP, HONORARY_POST, SEASONAL_WORK].includes(careerType.naturalId);
}